import { lazy } from "react";

export const Login = lazy(() =>
  import("./login").then((module) => ({
    default: module.Login,
  })),
);
